import { ListItemIcon, MenuItem, Typography } from '@mui/material';
import { AccountBox } from '@mui/icons-material';
import React from 'react';
import PropTypes from 'prop-types';

/** @component
 * Creates the profile item in the UserMenu.
 * @param onClick
 * @returns {React.Element}
 * @constructor
 */
export const ProfileMenuItem = ({ onClick }) => {
    return (
        <MenuItem
            key='ProfileMenuItem'
            onClick={onClick}
            data-analyticsid='account'
        >
            <ListItemIcon
                fontSize='inherit'
                style={{
                    verticalAlign: 'middle'
                }}
            >
                <AccountBox
                    style={{
                        width: '1.25rem',
                        height: '1.25rem'
                    }}
                />
            </ListItemIcon>
            <Typography variant='body2'>Profile</Typography>
        </MenuItem>
    );
};

ProfileMenuItem.propTypes = {
    onClick: PropTypes.func.isRequired
};
